export const randomSelect = (array) =>
  array[Math.floor(Math.random() * array.length)];
